import { render, staticRenderFns } from "./BuildingFieldList.vue?vue&type=template&id=45e33f96&scoped=true&"
import script from "./BuildingFieldList.vue?vue&type=script&lang=js&"
export * from "./BuildingFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e33f96",
  null
  
)

export default component.exports